module.exports = __webpack_public_path__ + "static/media/competitor.a6f01cc3.svg";